
import React from "react";
import {
  TextField,
  Grid2,
} from "@mui/material";

import DecoSelect from "./DecoSelect";
import { hookTypeOptions, hookColourOptions } from "../constants/closetOptions";

export const createEmptyHookRow = () => ({
  hooktype: "",
  hookcolour: "",
  hookspercleatQuantity: "",
  cleatQuantity: "",
});

const blockNonDigitKeys = (e) => {
  const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"];
  if (!/^\d$/.test(e.key) && !allowedKeys.includes(e.key)) {
    e.preventDefault();
  }
};

export default function HookRowFields({ row, index, onFieldChange, fieldErrors = {} }) {
  const { hooktype, hookcolour, hookspercleatQuantity, cleatQuantity } = row;

  const availableHookColours = hooktype ? hookColourOptions[hooktype] || [] : [];
  const hasError = (field) => !!fieldErrors[`${index}-${field}`];

  return (
    <Grid2 container spacing={2}>
      {/* Row 1: Hook Type + Hook Colour */}
      <Grid2 size={6}>
        <DecoSelect
          label="Hook Type"
          menuItems={hookTypeOptions}
          value={hooktype || ""}
          isError={hasError("hooktype")}
          onChange={(e) =>
            // Changing the type invalidates colour/quantities picked for
            // the previous type, so reset them atomically.
            onFieldChange(index, {
              hooktype: e.target.value,
              hookcolour: "",
              hookspercleatQuantity: "",
              cleatQuantity: "",
            })
          }
        />
      </Grid2>
      <Grid2 size={6}>
        <DecoSelect
          label="Hook Colour"
          menuItems={availableHookColours}
          value={hookcolour || ""}
          isError={hasError("hookcolour")}
          disabled={!hooktype}
          onChange={(e) =>
            onFieldChange(index, {
              hookcolour: e.target.value,
              hookspercleatQuantity: "",
              cleatQuantity: "",
            })
          }
        />
      </Grid2>

      {/* Row 2: Hooks per cleat + Cleat Sets */}
      <Grid2 size={6}>
        <TextField
          fullWidth
          label="Hooks per Cleat Quantity"
          value={hookspercleatQuantity}
          error={hasError("hookspercleatQuantity")}
          disabled={!hookcolour}
          inputMode="number"
          onChange={(e) => {
            const v = e.target.value;
            if (v === "" || /^[1-9]\d*$/.test(v)) {
              onFieldChange(index, { hookspercleatQuantity: v });
            }
          }}
          onKeyDown={blockNonDigitKeys}
        />
      </Grid2>
      <Grid2 size={6}>
        <TextField
          fullWidth
          label="No. of Cleat Sets"
          value={cleatQuantity}
          error={hasError("cleatQuantity")}
          disabled={!hookspercleatQuantity || hookspercleatQuantity === "0"}
          inputMode="Text"
          onChange={(e) => {
            const v = e.target.value;
            if (v === "" || /^[1-9]\d*$/.test(v)) {
              onFieldChange(index, { cleatQuantity: v });
            }
          }}
          onKeyDown={blockNonDigitKeys}
        />
      </Grid2>
    </Grid2>
  );
}
